export default {
  today () {
    const date = new Date()
    const y = date.getFullYear()
    let m = date.getMonth() + 1
    let d = date.getDate()
    if (m < 10) {
      m = '0' + m
    }
    if (d < 10) {
      d = '0' + d
    }
    return y + '-' + m + '-' + d
  },
  yesterday () {
    const date = new Date()
    let y = date.getFullYear()
    let m = date.getMonth()
    let d = date.getDate() - 1
    const yes = new Date(y, m, d)
    y = yes.getFullYear()
    m = yes.getMonth() + 1
    d = yes.getDate()
    if (m < 10) {
      m = '0' + m
    }
    if (d < 10) {
      d = '0' + d
    }
    return y + '-' + m + '-' + d
  }
}



// WEBPACK FOOTER //
// ./src/utils/formatDate.js